import { ReactElement } from 'react';
import { SvgIconProps } from '@material-ui/core';

export interface AlmeMinimizeConfig {
    minimize: {
        isMinimizeEnabled: boolean;
        styles: {
            buttonSize?: SvgIconProps['fontSize'];
        };
        minimizeIcon?: ReactElement;
    };
}

/**
 * This is the baseline minimize config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeMinimizeConfig = {
    minimize: {
        isMinimizeEnabled: true,
        styles: {},
    },
};

export default defaultConfig;